export default __webpack_public_path__ + "static/media/- Pionero1.476ab85b.jpg";